/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # ROC Selections Module

define('modules/Product/Selections',[
    'jquery',
    'lodash',
    'global/all'
], function ($, _, Roc) {
    'use strict';

    // private
    // Auto-select attribute values (options) if there is only one available for particular attribute
    var _autoSelect = true;
    var _productId;
    var _model;
    var items = {};
    var selections = {};
    var options = {};
    var _apiUrl;
    var $hdnProductId;

    function updateDisplayOfItem(product) {
        Roc.Logger.info('Selections -> getProduct');
        Roc.Logger.info(product);
        Roc.EventManager.notify(Roc.Events.products.SELECTIONS_UPDATE, product);
    }

    function getProduct(id) {
        Roc.Data.getAsync({
            url: _apiUrl + '/api/product/' + id + '/',
            callback: updateDisplayOfItem
        });
    }

    function getAvailableOptions(selectedOptions) {
        // Filter items matching current selections
        var availableItems = _.filter(items, function (item) {
            var matches = true;
            _.forEach(selectedOptions, function (selectedOption) {
                if (!_.some(item.selections, selectedOption)) {
                    matches = false;
                }
            });
            return matches;
        });

        var availableOptions = {};
        // Initialize available options object with attribute ids as keys
        _.forEach(selections, function (selection) { availableOptions[selection.attributeId] = []; });

        // Get all available options based on matched items
        _.forEach(availableItems, function (item) {
            _.forEach(item.selections, function (option) {
                if (availableOptions[option.attributeId].indexOf(option.attributeValueId) === -1) {
                    availableOptions[option.attributeId].push(option.attributeValueId);
                }
            });
        });

        return availableOptions;
    }

    function updateAvailableOptions() {
        var selectedOptions = getCurrentOptions();
        _.each(selections, function (selection) {
            // Filter available options based on selected options except current attriubte
            var opts = _.filter(selectedOptions, function (o) { return o.attributeId != selection.attributeId; });
            var availableOptions = {};
            if (opts.length > 0) {
                // If there are any selections, get available options for them
                availableOptions = getAvailableOptions(opts);
            } else {
                // If selections are empty, then get all available options for this attribute from selections data
                availableOptions[selection.attributeId] = [];
                _.each(selection.options, function (o) {
                    availableOptions[selection.attributeId].push(o.attributeValueId);
                });
            }

            var activeOptions = availableOptions[selection.attributeId];
            switch (selection.selectType.toLowerCase()) {
                case 'dropdown':
                    $('#' + selection.attributeId + ' option').each(function () {
                        if ($(this).val().length > 0) {
                            if (activeOptions.indexOf($(this).val()) > -1) {
                                $(this).removeClass('disabled');
                            } else {
                                $(this).addClass('disabled');
                            }
                        }
                    });

                    break;
                case 'swatch':
                case 'box':
                    $('#' + selection.attributeId + ' li').each(function () {
                        if (activeOptions.indexOf($(this).attr('id')) > -1) {
                            $(this).removeClass('disabled');
                        } else {
                            $(this).addClass('disabled');
                        }
                    });

                    break;
                default:
                    break;
            }
        });
    }

    function getCurrentOptions() {
        // Grab current selections for all options (so far)
        var activeOptions = [];
        var selectionCount = 0;
        $('input[id^=\'currentValue_\']').each(function () {
            if ($(this).val() !== '') {
                var attributeId = $(this).attr('id').replace('currentValue_', '');
                var option = { "attributeValueId": $(this).val(), "attributeId": attributeId };
                activeOptions[selectionCount] = option;
                selectionCount++;
            }
        });
        return activeOptions;
    }

    function updateCurrentItem() {
        var currentOptions = getCurrentOptions();

        // If all selections are filled, find the matching item.
        if (_model.selections.length === currentOptions.length) {
            var matchingItem = null;
            $.each(items, function () { // cycle the available permutations
                var matchedSelection = true;
                for (var i = 0; i < this.selections.length; i++) {
                    var found = false;
                    for (var j = 0; j < currentOptions.length; j++) { // check each set of attributes against the currently selected ones
                        if (currentOptions[j].attributeValueId === this.selections[i].attributeValueId) {
                            found = true;
                        }
                    }

                    if (found === false) {
                        matchedSelection = false;
                    }
                }
                if (matchedSelection === true) {
                    matchingItem = this;
                }
            });

            if (matchingItem) {
                getProduct(matchingItem.id);
                $hdnProductId.val(matchingItem.id);
            }
        } else {
            // display group item.
            getProduct(_productId);   // _productId = group ItemId
            $hdnProductId.val('');
        }
    }

    function selectAttributeValue(selectionAttributeValueId, unavailableOptionSelected) {
        // We allow to select unavailable option in dropdown selection
        // because we do not disable them when other selections are made.
        // When user selects unavailable option we need to disable other attributes

        var option = options[selectionAttributeValueId];
        if (option === null) {
            return;
        }  // empty select?

        var selection = selections[option.attributeId];

        if (unavailableOptionSelected) {
            //DeselectAttributeValue(option.attributeId, false);
            var selectedOptions = getCurrentOptions();
            var availableOptions1 = getAvailableOptions(selectedOptions);
            // update selected option with selection attribue value id
            _.each(selectedOptions, function (selOption) {
                if (selOption.attributeId === option.attributeId) {
                    selOption.attributeValueId = selectionAttributeValueId;
                }
            });
            var availableOptions2 = getAvailableOptions(selectedOptions);
            for (var attrId in availableOptions1) {
                for (var optionId in availableOptions1[attrId]) {
                    if (availableOptions2[attrId].indexOf(optionId) < 0 && attrId !== option.attributeId) {
                        deselectAttributeValue(attrId, false);
                    }
                }
            }
        }

        // Set selection text
        $('#selected_' + selection.attributeId).html(option.value);
        $('#deselect_' + selection.attributeId).show();

        // Set hidden value of current selection
        $('#currentValue_' + selection.attributeId).val(option.attributeValueId);

        // Iterate through all the existing options for this attribute and remove the active flag.
        //selection.options.forEach(function (option) {
        //    $('#' + option.attributeValueId)
        //        .removeClass('active selected')
        //        .attr('aria-checked', 'false');
        //});

        // Set 'Active' flag for the option user just selected
        $('#' + option.attributeValueId).addClass('active selected');

        // Disable options which are no longer valid.
        updateAvailableOptions();

        // Update display for item (if all options are set).
        updateCurrentItem();
    };

    function deselectAttributeValue(selectionAttributeId) {
        var selection = selections[selectionAttributeId];

        // Set selection text
        $('#selected_' + selection.attributeId).html('');
        $('#deselect_' + selection.attributeId).hide();

        if (selection.selectType.toLowerCase() === 'dropdown') {
            $('#' + selection.attributeId).val($('#' + selection.attributeId + ' option:first').val());
        }

        // Set hidden value of current selection
        $('#currentValue_' + selection.attributeId).val('');

        selection.options.forEach(function (option) {
            $('#' + option.attributeValueId)
                .removeClass('active selected')
                .attr('aria-checked', 'false')
                .closest('ul').attr('aria-activedescendant', '');
        });

        updateAvailableOptions();
        updateCurrentItem();        
    }

    // displays alert message if there is no matching item
    function unavailableSelection(selectedAttributeValueId) {
        var option = options[selectedAttributeValueId];
        if (option === null) {
            return;
        }  // empty select?
        var selection = selections[option.attributeId];

        var selectedOptions = getCurrentOptions();
        var currentSelections = '';
        for (var idx in selectedOptions) {
            var opt = options[selectedOptions[idx].attributeValueId];
            if (opt.attributeId !== option.attributeId) {
                if (currentSelections.length === 0) {
                    currentSelections += opt.value;
                } else {
                    currentSelections += ' & ' + opt.value;
                }
            }
        }

        Roc.UI.Modal.alert(option.value + ' is unavailable in ' + currentSelections + '.', 'Please Select a different ' + selection.name);
    };

    function init(apiUrl, model) {
        _apiUrl = apiUrl;
        _productId = model.id;
        _model = model;

        var i;
        // Hydrate item permutations
        for (i = 0; i < _model.items.length; i++) {
            items[_model.items[i].id] = _model.items[i];
        }

        // Hydrate selections and options
        for (i = 0; i < _model.selections.length; i++) {
            selections[_model.selections[i].attributeId] = _model.selections[i];
            for (var j = 0; j < _model.selections[i].options.length; j++) {
                _model.selections[i].options[j].attributeId = _model.selections[i].attributeId;
                options[_model.selections[i].options[j].attributeValueId] = _model.selections[i].options[j];
            }
        }

        // Hidden field to save current product id based on selections made by user
        $hdnProductId = $('#hdnProductId');

        $('input[id^="currentValue_"]').each(function () {
            // Clear all cached values
            $(this).val('');
            // Ensure input have proper value
            var attrId = $(this).attr('id').split('_').pop();
            $('#' + attrId).val('');
        });


        // Auto-select
        if (_autoSelect) {
            _.forEach(selections, function (selection) {
                if (selection.options.length === 1) {
                    var option = selection.options[0];
                    switch (selection.selectType.toLowerCase()) {
                        case 'dropdown':
                            $('#' + selection.attributeId).val(option.attributeValueId);
                            break;
                        case 'swatch':
                        case 'box':
                            $('#' + selection.attributeId + ' li#' + option.attributeValueId).addClass('active selected').attr('aria-checked', 'true');
                            break;
                        default:
                            break;
                    }
                    selectAttributeValue(option.attributeValueId);
                }
            });

            updateAvailableOptions();
        }
    }

    var Selections = {
        init: init,
        GetProduct: getProduct,
        GetAvailableOptions: getAvailableOptions,
        UpdateAvailableOptions: updateAvailableOptions,
        GetCurrentOptions: getCurrentOptions,
        SelectAttributeValue: selectAttributeValue,
        DeselectAttributeValue: deselectAttributeValue,
        UnavailableSelection: unavailableSelection
    };

    Roc.Logger.debug('Selections.js Loaded:', Selections);

    return Selections;
});
